import React, { useState, useEffect } from 'react'
import Modal from '../modal/index'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { getOffers, getCategories } from '../../../services/api'

import {
  INTEREST_DEFAULT_LINK, SUBSCRIBE_PATH
} from '../../../general/global_variables'

export default function Courses({ pageContent }) {
  const [allOffers, setOffers] = useState()
  const [filteredOffers, setFilteredOffers] = useState()
  const [selectedOffer, setSelectedOffer] = useState()
  const [categories, setCategories] = useState()
  const [loading, setLoading] = useState(false)
  const [openDetails, setOpenDetails] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [activeLoadMore, setActiveLoadMore] = useState([])

  useEffect(() => {
    getOffers().then((response) => {
      setLoading(true)
      setOffers(response.data);
      setFilteredOffers(response.data);
    }).finally(() => {
      setLoading(false)
    });
  }, [])

  const handleLoadMore = (category) => {
    let count_by_category = activeLoadMore.filter((item) => item.category === category)
    if (count_by_category.length > 0) {
      const updated_values = activeLoadMore.map((item) => {
        if (item.category === category) {
          return {
            ...item,
            sliceCount: item.sliceCount + 3,
          };
        }

        return item;
      })
      setActiveLoadMore(updated_values)
    } else {
      let new_item = { "category": category, "sliceCount": 6 }
      setActiveLoadMore((values) => [...values, new_item])
    }

  }

  const handleSearch = (value) => {
    var term = value.toLowerCase()
    setSearchTerm(term)
    const result = allOffers
      .map(item => ({
        ...item,
        offers: item.offers.filter(child => 
           (child.course_name && child.course_name.toLowerCase().includes(value.toLowerCase())) ||
          (child.exam_name && child.exam_name.toLowerCase().includes(value.toLowerCase()))
        )
      }))
      .filter(item => item.offers.length > 0)
    
    console.log(result)
    setFilteredOffers(result)
  }

  const handleOfferDetails = (offer) => {
    setSelectedOffer(offer)
    setOpenDetails(true)
  }

  const normalizeOldPrice = (price) => {
      if(!price) return price

      var normalized_price = price.split("\n")
      return normalized_price[0]
  }

  const normalizePrice = (price) => {
    if(!price) return price

    var normalized_price = price.split("\n")
    return normalized_price[1]
}
  
  const normalizeAdditionalPriceInformation = (price) => {
    if(!price) return price

    var normalized_price = price.split("\n")
    return normalized_price[2]
  }

  const formatPriceWithSupDecimal = (normalizedPrice) => {
    if(!normalizedPrice) return normalizedPrice

    if(normalizedPrice.includes(",00")){
      var splitted_price = normalizedPrice.split(",")
      return <>{splitted_price[0]}<sup className="superscript">,{splitted_price[1]}</sup></>
    }

    return normalizedPrice
  }

  const generateSubscribeLink = (offer) => {
    //IF is interest return interest ens link
    if (offer.show_as_interest) return INTEREST_DEFAULT_LINK
    //If is external link return it
    if (offer.subscribe_external_link) return offer.subscribe_external_link
    //if exists subscribe link and there's no errors
    if (offer.subscribe_link) {
      //if there is a voucher
      if (pageContent?.voucher_param && pageContent?.voucher_value) {
        return `${offer.subscribe_link}&${pageContent?.voucher_param}=${pageContent?.voucher_value}`
      } else {
        // normal conditional
        return offer.subscribe_link
      }

    } else {
      return INTEREST_DEFAULT_LINK
    }

  }

  const renderCourses = (offers, category) => {
    // const get_slice_from_category = activeLoadMore.find((item) => item.category === category.id)
    // console.log(get_slice_from_category)
    // var sliceNumber = 3
    // if (get_slice_from_category != null) { sliceNumber = get_slice_from_category.sliceCount }
    // var courses_of_category = filteredOffers?.filter((item) => item.course_category_id == category.id_admin_ens).slice(0, sliceNumber);
    
    var offer_count = activeLoadMore.find((item) => item.category === category)?.sliceCount || 3

    return (
      <>
        {
          !loading && offers?.slice(0, offer_count).map((course, index) => (
            <div className="course-item-box" key={index} data={offer_count}>
              <div className="course-item-columns w-row">
                <div className="item-left-column w-col w-col-8">
                  <div className="course_info-box">
                    <div className="course-title">{course.course_name || course.exam_name}</div>
                    <p className="course-text">Inscreva-se:</p>
                    <div className="course-buttons-box">
                      <a onClick={() => handleOfferDetails(course)} className="course-default-button alt-button" >Saiba Mais</a>
                      {
                        pageContent?.associate_link && 
                        <a href={pageContent?.associate_link } className="course-default-button secondary-button">Associados</a>
                      }
                      <a href={generateSubscribeLink(course)} className="course-default-button default-button">
                        {
                          (course.show_as_interest || !course.subscribe_link)  ? "Avise-me" : "Não Associados"
                        }
                      </a>
                    </div>
                  </div>
                </div>
                <div className="item-right-column w-col w-col-4">
                  <div className="course-date-box">
                    <img src="/assets/images/calendar-icon.png" loading="lazy" alt="" className="image-34" />
                    <div className="course-date">{course.course_initial_date == "01/01/2023" ? "Início Imediato": course.course_initial_date || course.exam_initial_register_date }</div>
                  </div>
                  <div className="course-investment-box">
                  
                    <div className="course__old-price">{normalizeOldPrice(course.investment_old_price)}</div>
                    <div className="course_price">{formatPriceWithSupDecimal(normalizePrice(course.investment_old_price))}</div>
                    <div className="course_discount">{normalizeAdditionalPriceInformation(course.investment_old_price)}</div> 
                  </div>
                </div>
              </div>
            </div >
          ))
        }

        {
          !loading && offers?.length > offer_count &&
          <div className="course_load-more-box">
            <a onClick={() => handleLoadMore(category)} className="course-default-button alt-button">mais {category}</a>
          </div>
        }
    

      </>
    )

  }

  return (
    <div id="section__courses">
      {openDetails && <Modal offer={selectedOffer} setOpenDetails={setOpenDetails} />}
      <section className="section__courses">
        <div className="center center__inner justify-center">
          <div className="courses__container">
            <div className="courses_filter-container">
              <div className="banner__info-uppertitle text-center">PROCURE POR PALAVRA</div>
              <div className="courses_form-filter w-form">
                <img src="/assets/images/search.png"  className="search-icon" alt="icone com formato de lupa" />
                <input onChange={(ev) => handleSearch(ev.target.value)} value={searchTerm} type="text"
                  className="form-filter-input w-input" maxLength="256" placeholder="Digite aqui"
                />   
              </div>
            </div>
            {
              !filteredOffers &&
                <SkeletonTheme baseColor="#aad7db14" highlightColor="#9fcfd3" height="25px">
                  <Skeleton count={5} />
                </SkeletonTheme>
            }

            {
              filteredOffers?.map((data, index) => (
                <div className="course_category-section" key={index}>
                  <h2 className="title__center">{data.course_type || data.exam_type}</h2>
                  <div className="course-list w-container">

                    {
                      renderCourses(data.offers, data.course_type || data.exam_type)
                    }
        
                  </div>
                </div>
              ))
            }
           

          </div>
        </div>
      </section>
    </div>
  )
}
